import gql from 'graphql-tag';

import { FAQ_NOTIFICATION_FRAGMENT } from './faqNotification';
import { PLEX_NOTIFICATION_FRAGMENT } from './plexNotification';
import { POST_NOTIFICATION_FRAGMENT } from './postNotification';

export const FEED_NOTIFICATION_FRAGMENT = gql`
  fragment feedNotification on FeedNotification {
    __typename
    ... on PostNotification {
      __typename
      ...postNotification
    }
    ... on FaqNotification {
      __typename
      ...faqNotification
    }
    ... on PlexNotification {
      __typename
      ...plexNotification
    }
  }
  ${POST_NOTIFICATION_FRAGMENT}
  ${FAQ_NOTIFICATION_FRAGMENT}
  ${PLEX_NOTIFICATION_FRAGMENT}
`;
